import {
  Box,
  BoxProps,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React, { FC } from 'react';

const TitleLogo: FC<BoxProps> = props => {
  const classes = useStyles();

  return (
    <Box
      fontWeight="fontWeightBold"
      fontSize="h4.fontSize"
      color="primary.main"
      className={classes.boxStyle}
      {...props}
    >
      {'FITQUARTERS'}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxStyle: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.text.primary
          : theme.palette.primary.main,
    },
  })
);

export default TitleLogo;
